import { render, staticRenderFns } from "./PageHeaderMobile.vue?vue&type=template&id=12651789"
import script from "./PageHeaderMobile.vue?vue&type=script&lang=js"
export * from "./PageHeaderMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports